import {faFilter} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TableColumnType} from 'antd';

import {Locale} from '../../../../provider/locale/locale';
import {TableSorterHookReturnType} from '../../../../util/antd/table/table-sorter-hook';
import {TupleType} from '../../../../util/type';

import {TagsTableRowDataType} from './tags-table-type';

enum TagColumnTableKeyEnum {
    Title = 'title',
    TagGroup = 'tagGroup',
    TagActions = 'tagAction',
    CreatedAt = 'createdAt',
}

export function getTagColumnList(
    getSortOrder: TableSorterHookReturnType<TagColumnTableKeyEnum>['getSortOrder']
): TupleType<TableColumnType<TagsTableRowDataType>, 4> {
    return [
        {
            title: <Locale stringKey="TAGS__TAG" />,
            dataIndex: 'title',
            sorter: true,
            sortOrder: getSortOrder(TagColumnTableKeyEnum.Title),
        },
        {
            title: <Locale stringKey="TAGS__GROUP" />,
            dataIndex: 'tagGroup',
            filterIcon: <FontAwesomeIcon icon={faFilter} size="lg" />,
        },
        {
            title: <Locale stringKey="TABLE__HEADER__DATE_OF_CREATION" />,
            dataIndex: 'createdAt',
            sorter: true,
            sortOrder: getSortOrder(TagColumnTableKeyEnum.CreatedAt),
        },
        {
            title: <Locale stringKey="TAGS__ACTIONS" />,
            dataIndex: 'tagActions',
            width: 104,
        },
    ];
}

export const withoutGroupItemId = '-1';

// see TagDataType.is_complex
// is_complex === true => command
// is_complex === false => private
export const tagTypeCommand = 'public';
